import { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../../../context/authContext';

export const useNavbarLogic = () => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [notificationOpen, setNotificationOpen] = useState(false);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    
    const { logout, currentUser } = useContext(AuthContext);
    const location = useLocation();

    useEffect(() => {
        setDropdownOpen(false);
        setNotificationOpen(false);
        setShowLogoutModal(false);
    }, [location]);

    const toggleDropdown = () => {
        setNotificationOpen(false); 
        setDropdownOpen(prev => !prev);
    };

    const closeUserDropdown = () => setDropdownOpen(false);

    const handleLogoutClick = () => {
        setDropdownOpen(false);
        setShowLogoutModal(true);
    };

    const confirmLogout = () => {
        logout();
        setShowLogoutModal(false);
    };

    const cancelLogout = () => {
        setShowLogoutModal(false);
    };

    return {
        state: { dropdownOpen, notificationOpen, showLogoutModal },
        setters: { setDropdownOpen, setNotificationOpen },
        actions: { 
            toggleDropdown, 
            closeUserDropdown, 
            handleLogoutClick, 
            confirmLogout, 
            cancelLogout 
        },
        currentUser
    };
};